import { type ReportAiCommentBody, reportApi } from '@mathflat/domain/Report'

import type { AchievementReportAiCommentBody } from '@/api/aiApi'
import aiApi from '@/api/aiApi.ts'
import type { Student } from '@/dto'

class AiController {
  getSessionId = async () => {
    return reportApi.createAiSession()
  }

  createAiComment = async (
    sessionId: string,
    studentId: Student['id'],
    payload: AchievementReportAiCommentBody,
  ) => {
    return await aiApi.createAiComment(sessionId, studentId, payload)
  }

  createReportComment = (payload: ReportAiCommentBody, signal?: AbortSignal) =>
    reportApi.createReportAiComment(payload, signal)
}

export const aiController = new AiController()
